// src/utils/permissionHelper.js

/**
 * Permission mapper - maps UI routes/features to backend permissions
 */
const PERMISSION_MAP = {
  // Group permissions
  '/addgroup': { permission: 'GROUP', privilege: 'CREATE' },
  '/updategroup': { permission: 'GROUP', privilege: 'UPDATE' },

  // User permissions
  '/adduser': { permission: 'USER', privilege: 'CREATE' },
  '/updateuser': { permission: 'USER', privilege: 'UPDATE' },
  '/viewuser': { permission: 'USER', privilege: 'VIEW' },

  // Payment Link permissions
  '/referrallink': { permission: 'REFERRALLINK', privilege: 'CREATE' },
  '/viewreflink': { permission: 'REFERRALLINK', privilege: 'VIEW' },
  '/viewprlink': { permission: 'PAYMENTREF', privilege: 'VIEW' },
  '/viewpaymentlink': { permission: 'PAYMENTLINK', privilege: 'VIEW' },
  '/pr': { permission: 'PAYMENTREF', privilege: 'VIEW' },

  // Transaction permissions
  '/transactions': { permission: 'TRANSACTION', privilege: 'VIEW' },

  // Permission Management
  '/permuser': { permission: 'PERMISSION', privilege: 'UPDATE' },

  // Admin/Leader
  '/addadmin': { permission: 'ADMIN', privilege: 'CREATE' },
  '/updateadmin': { permission: 'ADMIN', privilege: 'UPDATE' },
  '/viewadmin': { permission: 'ADMIN', privilege: 'VIEW' },

  // FPX Bank
  '/fpxbank': { permission: 'FPXBANK', privilege: 'VIEW' },

  // CSV
  //'/csv-download': { permission: 'CSV', privilege: 'DOWNLOAD' },

  // Receipts
  '/receipts': { permission: 'RECEIPT', privilege: 'VIEW' },

  // Logs
  '/log': { permission: 'LOG', privilege: 'VIEW' },
}

/**
 * Check if user has specific permission and privilege
 */
export const hasPermission = (userPermissions, permission, privilege) => {
  if (!userPermissions || !Array.isArray(userPermissions)) {
    return false
  }
  //console.log('userPermissions', userPermissions)
  return userPermissions.some(
    (perm) => perm.permission === permission && perm.privilege === privilege,
  )
}

/**
 * Check if user has any privilege for a permission
 */
export const hasAnyPrivilegeForPermission = (userPermissions, permission) => {
  if (!userPermissions || !Array.isArray(userPermissions)) {
    return false
  }

  return userPermissions.some((perm) => perm.permission === permission)
}

/**
 * Check if user has access to a specific route
 */
export const hasRouteAccess = (userPermissions, route) => {
  const requiredPermission = PERMISSION_MAP[route]
  //console.log('route', route)
  //console.log('requiredPermission', requiredPermission)
  if (!requiredPermission) {
    // Route doesn't require specific permission (like dashboard, logout)
    return true
  }

  let hp = hasPermission(
    userPermissions,
    requiredPermission.permission,
    requiredPermission.privilege,
  )

  console.log('hp', hp)
  return hp
}

/**
 * Filter navigation items based on user permissions
 */
export const filterNavigationByPermissions = (navItems, userPermissions) => {
  return navItems
    .map((item) => {
      // If item has children (CNavGroup)
      if (item.items) {
        const filteredItems = item.items.filter((child) =>
          hasRouteAccess(userPermissions, child.to),
        )
        //console.log('filteredItems', filteredItems)
        // Only include group if it has visible children
        if (filteredItems.length > 0) {
          return {
            ...item,
            items: filteredItems,
          }
        }
        return null
      }

      // Single item (CNavItem)
      if (item.to && item.to !== '/dashboard' && item.to !== '/logout') {
        if (hasRouteAccess(userPermissions, item.to)) {
          return item
        }
        return null
      }

      // Always show dashboard and logout
      return item
    })
    .filter((item) => item !== null)
}

/**
 * Get user permissions from localStorage
 */
export const getUserPermissions = () => {
  try {
    const loginData = localStorage.getItem('login')
    console.log('loginData', loginData)
    if (!loginData) return []

    const parsed = JSON.parse(loginData)
    return parsed?.login?.permissionPrivilege || []
  } catch (error) {
    console.error('Error parsing user permissions:', error)
    return []
  }
}

/**
 * Check button access (for CRUD operations)
 */
export const canCreate = (userPermissions, permission) => {
  return hasPermission(userPermissions, permission, 'CREATE')
}

export const canView = (userPermissions, permission) => {
  return hasPermission(userPermissions, permission, 'VIEW')
}

export const canUpdate = (userPermissions, permission) => {
  return hasPermission(userPermissions, permission, 'UPDATE')
}

export const canDelete = (userPermissions, permission) => {
  return hasPermission(userPermissions, permission, 'DELETE')
}

export const canDownload = (userPermissions, permission) => {
  return hasPermission(userPermissions, permission, 'DOWNLOAD')
}
